export default __webpack_public_path__ + "static/media/ca.7576a074.svg";